<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="dialogForm" class="label-gray" label-width="100px" :rules="rules" ref="dialogForm">
      <el-form-item label="门店名称" prop="name">
        <el-input v-model.trim="dialogForm.name" autocomplete="off" clearable maxLength="18"></el-input>
      </el-form-item>
      <el-form-item label="门店类型" prop="type">
        <shop-type-select v-model="dialogForm.type" clearable/>
      </el-form-item>
      <el-form-item label="门店地区" prop="region">
        <region-cascade v-model="dialogForm.region" clearable/>
      </el-form-item>
      <el-form-item label="门店电话" prop="telephone">
        <el-input v-model.trim="dialogForm.telephone" autocomplete="off" clearable maxLength="13"></el-input>
      </el-form-item>
      <el-form-item label="门店邮箱" prop="email">
        <el-input v-model.trim="dialogForm.email" autocomplete="off" clearable></el-input>
      </el-form-item>
      <el-form-item label="门店地址" prop="address">
        <el-input v-model.trim="dialogForm.address" clearable></el-input>
      </el-form-item>
      <el-form-item label="门店介绍" prop="introduce">
        <el-input v-model.trim="dialogForm.introduce" type="textarea" :autosize="{minRows: 4}" maxlength="128" show-word-limit resize="none"></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty,changeEmpty,checkNickName,checkMailbox,checkTelephone} from '@utils/validate'
  import RegionCascade from "@view/components/cascader/RegionCascade"
  import ShopTypeSelect from "@view/components/select/ShopTypeSelect"
  export default {
    name: "ReviseShop",
    components: {RegionCascade,ShopTypeSelect},
    props: {dialogData: Object},
    data() {
      return {
        dialogForm: {
          name: "",
          type: "",
          region: "",
          telephone: "",
          email: "",
          address: "",
          introduce: "",
        },
        rules: {
          name: [inputEmpty("商家门店名"),checkNickName("商家门店名")],
          type: [changeEmpty("商家类型")],
          region: [changeEmpty('商家区域')],
          telephone: [checkTelephone()],
          email: [checkMailbox()],
        },
      }
    },
    methods: {
      confirm() {
        let row = this.dialogData.row;
        let nv = {};
        for(let [key, val] of Object.entries(this.dialogForm)) {
          if (val !== this.showData(key, row, "")) {
            nv[key] = val
          }
        }
        if (Object.keys(nv).length) {
          this.$refs["dialogForm"].validate(isOk => {
            if (isOk) {
              this.openConfirm("修改该商家信息", async () => {
                nv.optionId = row.id;
                let res = await this.$Http.reviseShop(nv);
                if (res) {
                  this.msgSuccess("修改成功");
                  this.$emit("table-reload");
                  this.dialogData.visible = false;
                }
              });
            }
          });
        } else {
          this.msgInfo("您尚未做任何修改")
        }
      },
    },
    created() {
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.dialogForm).forEach(key => this.dialogForm[key] = this.showData(key, row, ""));
      }
    }
  }
</script>

<style scoped>

</style>
